import React, { useState } from "react";

const fmt = (n) => n ? Number(n).toLocaleString("en-SA") : "0";

export default function DalalaTooltip({ record, children }) {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const handleEnter = (e) => {
    const rect = e.target.getBoundingClientRect();
    setPos({ x: rect.left, y: rect.bottom + 4 });
    setShow(true);
  };

  const ext = Number(record.ext_marketer_share) || 0;
  const int_ = Number(record.int_marketer_share) || 0;
  const waha = Number(record.waha_share) || 0;
  const sm = Number(record.sales_mgr_share) || 0;
  const mm = Number(record.mkt_mgr_share) || 0;
  const co = Number(record.company_share) || 0;
  const dalala = Number(record.dalala_amount) || 0;
  const hasData = dalala > 0;

  return (
    <span onMouseEnter={handleEnter} onMouseLeave={() => setShow(false)} style={{ position: "relative", cursor: hasData ? "help" : "default" }}>
      {children}
      {show && hasData && (
        <div style={{
          position: "fixed", left: pos.x, top: pos.y, zIndex: 300,
          background: "#1e293b", color: "#e2e8f0", borderRadius: 10,
          padding: "12px 16px", boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
          fontSize: 12, minWidth: 220, direction: "rtl",
        }}>
          <div style={{ fontWeight: 700, marginBottom: 8, color: "#10b981", fontSize: 14 }}>
            تفاصيل الدلالة: {fmt(dalala)} ر.س
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <Row label="المسوق الخارجي" value={ext} total={dalala} color="#f59e0b" />
            <Row label="المسوق الداخلي" value={int_} total={dalala} color="#3b82f6" />
            <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", margin: "4px 0", paddingTop: 4 }}>
              <div style={{ fontSize: 10, color: "#64748b", marginBottom: 3 }}>توزيع الداخلي:</div>
              <Row label="الواحة" value={waha} total={int_} color="#8b5cf6" indent />
              <Row label="م. المبيعات" value={sm} total={int_} color="#06b6d4" indent />
              <Row label="م. المسوقات" value={mm} total={int_} color="#ec4899" indent />
              <Row label="الشركة" value={co} total={int_} color="#10b981" indent />
            </div>
          </div>
        </div>
      )}
    </span>
  );
}

function Row({ label, value, total, color, indent }) {
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, paddingRight: indent ? 12 : 0 }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: color, flexShrink: 0 }} />
      <span style={{ flex: 1, fontSize: 11 }}>{label}</span>
      <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11 }}>{fmt(value)}</span>
      <span style={{ fontSize: 10, color: "#64748b", width: 35, textAlign: "left" }}>{pct}%</span>
    </div>
  );
}
